module.exports = __webpack_public_path__ + "img/home_bg.927a5693.jpg";